/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ico-bath': {
    width: 16,
    height: 16,
    viewBox: '0 0 300 300',
    data: '<path pid="0" d="M250 178h-6V70a24 24 0 00-47.71-3.71A24 24 0 00176 90v4h48v-4a24 24 0 00-19.58-23.59A16 16 0 01236 70v108H50v4h6v20.11c0 21.81 17.61 39.78 40 41.71V250h8v-6h92v6h8v-6.18c22.39-1.93 40-19.9 40-41.71V182h6zm-34.51-92h-31a16 16 0 0131 0zM236 202.11c0 18.68-16.15 33.89-36 33.89H100c-19.85 0-36-15.21-36-33.89V182h172z"/><path pid="1" d="M178 100h4v10h-4zM198 110h4v10h-4zM218 100h4v10h-4z"/>'
  }
})
